import OnestockDashboardContainer from "./OnestockDashboardContainer";
import OnestockDashboardStore from "./OnestockDashboardStore";

export default OnestockDashboardStore(OnestockDashboardContainer);